export default __webpack_public_path__ + "static/media/pcGroup.70cb350a.svg";